import React from "react";
import Data from '../Data.json';

const SocialLinks = () => {
    return (
      <ul className="flex flew-row">
  
        {/* For each logo in Data.socials... */}
        {Data.socials.map((social) => (
          <div key={social.id}>
            <li className="mr-3">
                <a href={social.href}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-medium me-2" viewBox="0 0 16 16">
                        <path d={social.path_d}/>
                    </svg>
                </a>
              </li>
          </div>
        ))}
  
        {/* Additional logo */}
        <li className="mr-3">
          <a href="https://www.duolingo.com/profile/Matt90811">
              <img src="duolingo-logo.svg" alt="Duolingo icon" width="80" height="24" id="duolingo-icon" className="my-1"></img>
          </a>
        </li>
  
        {/* Version number */}
        <li className="mr-3">
          <span className="text-xs leading-5 font-semibold bg-slate-400/10 rounded-full py-1 px-3">v2.0.8</span>
        </li>
      </ul>
    )
}

export default SocialLinks;